import React from 'react';
import * as types from '@/ui/shared/types';
import styles from './Spacing.module.scss';

export const Spacing = ({ spacing = 2, direction = 'vertical' }: types.Spacing) => (
  <div
    className={`${styles.spacing} ${styles[`spacing--${direction}`]}`}
    style={{ '--spacing': `${spacing * 8}px` } as React.CSSProperties}
  />
);
